import { render, staticRenderFns } from "./RegionsTable.vue?vue&type=template&id=6e8bbf9c"
import script from "./RegionsTable.vue?vue&type=script&lang=js"
export * from "./RegionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports